import React from 'react'

import { Skeleton } from '../Skeleton'
import { responsiveAdapter, responsiveAdapterVertical } from '@/utils'

interface SkeletonCardProps {
  height?: number
  width?: number
  radius?: number
  align?: 'center' | 'flex-start' | 'flex-end'
  paddingLeft?: number | string
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  height = 40,
  width,
  radius = 4,
  align,
  paddingLeft,
}) => {
  // Calculate width if not provided (similar to RN version)
  const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 375
  const defaultWidth = screenWidth - responsiveAdapter(24)
  const finalWidth = width ?? defaultWidth
  const finalHeight = responsiveAdapterVertical(height)

  return (
    <Skeleton
      viewBox={`0 0 ${finalWidth} ${finalHeight}`}
      style={{
        width: finalWidth,
        height: finalHeight,
        alignSelf: align,
        paddingLeft,
      }}
    >
      <rect rx={radius} ry={radius} width={finalWidth} height={finalHeight} />
    </Skeleton>
  )
}
